<template>
  <v-dialog v-model="dialog" max-width="300">
    <v-card>
      <v-card-title class="headline"> Confirmation </v-card-title>
      <v-card-text class="m--icon-font-size-sm1">
        Are you sure you want to switch to
        <span class="m--font-boldest">
          {{ user.name }} - {{ user.email }}
        </span>
        ?
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <v-btn color="darken-1" text @click="toggleConfirmDialog">
          Cancel
        </v-btn>
        <v-btn
          color="primary darken-1"
          text
          @click="proceed"
          :loading="loading"
          :disabled="loading"
        >
          Proceed
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ConfirmUserSwitch',
  props: ['dialog', 'user', 'toggleConfirmDialog'],
  data: () => ({
    loading: false,
  }),
  methods: {
    proceed() {
      this.loading = true;
      this.$http
        .post('/user/switch', {
          id: this.user.id,
        })
        .then(({ data }) => {
          this.loading = false;
          this.$auth.storeManager.setToken(data.token);
          this.$auth.storeManager.setUser(data.user);
          // eslint-disable-next-line no-restricted-globals
          location.reload();
        })
        .catch(() => {
          this.loading = false;
          this.$notify('error', 'Error loading the user. Please try again');
        });
    },
  },
};
</script>
